/* ==========================================================================
   VORTRIX — comportamento da PDP. Zero dependências.

   ⚠️ BUG QUE ISTO CORRIGE:
   Cada seção carrega <script src="vx-pdp.js">. Com 16 seções, o browser
   executa o arquivo 16 VEZES. Sem guarda, cada <summary> ganhava 16 listeners
   e o accordion abria/fechava 16x por clique — parecia que nunca abria.

   Toda inicialização abaixo é IDEMPOTENTE: marca o elemento com dataset e
   nunca o inicializa de novo. boot() pode rodar N vezes sem efeito colateral.

   ⚠️ A Shopify MINIFICA este arquivo ao servir: grep no servido mente.
   ========================================================================== */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* touch/mobile (iOS incluso): animar `height` no accordion faz o Safari
     re-rasterizar o texto a cada frame → "tremida". No touch deixamos o
     <details> abrir nativo (instantâneo, estável). Desktop mantém a animação. */
  var TOUCH = window.matchMedia('(hover: none) and (pointer: coarse)').matches;

  /* marca o elemento; devolve false se já foi inicializado */
  function claim(el, key) {
    if (el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }

  /* ---------------------------------------------------------------- galeria
     Padrão NORVEK: o stage é um scroller com scroll-snap. As thumbs rolam o
     stage; o scroll do stage acende a thumb. Nada de fade/slides absolutos. */
  function initGallery(root) {
    if (!claim(root, 'vxGal')) return;

    var track = root.querySelector('[data-gal-track]');
    var thumbs = root.querySelectorAll('[data-gal-thumb]');
    var prev = root.querySelector('[data-gal-prev]');
    var next = root.querySelector('[data-gal-next]');
    if (!track) return;
    var slides = track.querySelectorAll('[data-gal-slide]');
    if (slides.length < 2) return;

    function mark(i) {
      thumbs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    function goTo(i) {
      i = Math.max(0, Math.min(i, slides.length - 1));
      var s = slides[i];
      track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: REDUCED ? 'auto' : 'smooth' });
      mark(i);
    }

    function current() {
      var best = 0, dist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var d = Math.abs((slides[i].offsetLeft - track.offsetLeft) - track.scrollLeft);
        if (d < dist) { dist = d; best = i; }
      }
      return best;
    }

    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { goTo(k); }); });
    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });

    track.addEventListener('scroll', function () {
      window.clearTimeout(track._t);
      track._t = window.setTimeout(function () { mark(current()); }, 80);
    }, { passive: true });

    mark(0);
  }

  /* ------------------------------------------------- <details> com transição
     ⚠️ DUAS ARMADILHAS, AS DUAS JÁ ME MORDERAM:

     1) A transição não roda se o browser não tiver RECALCULADO o estilo com a
        altura fixa ANTES de você trocá-la por 0. requestAnimationFrame não
        garante isso: ele interpola de `auto` para `0`, que não é animável, e o
        resultado é um corte seco. A cura é FORÇAR O REFLOW (ler offsetHeight)
        entre fixar a altura e mudá-la.

     2) O padding-bottom não é comprimível. Com height:0 sobravam 24px de vão.
        Ele tem de entrar na transição também.

     Idempotente: claim() garante UM listener por summary. */
  function initDetails(d) {
    if (!claim(d, 'vxDet')) return;

    var sum = d.querySelector('summary');
    var body = d.querySelector('.vx-row__body');
    if (!sum || !body) return;
    if (REDUCED || TOUCH) return;   // touch/reduced: <details> nativo (sem tremida)

    var EASE = 'cubic-bezier(.22,.61,.36,1)';
    var DUR = 340;
    var busy = false;

    function clear() {
      body.style.transition = '';
      body.style.height = '';
      body.style.opacity = '';
      body.style.overflow = '';
      body.style.paddingBottom = '';
    }

    sum.addEventListener('click', function (e) {
      e.preventDefault();
      if (busy) return;
      busy = true;

      var pad = getComputedStyle(body).paddingBottom;

      if (d.open) {
        /* ---- FECHAR ---- */
        d.classList.add('is-closing');       // o ícone vira NA HORA do clique
        var h = body.scrollHeight;

        body.style.transition = 'none';
        body.style.overflow = 'hidden';
        body.style.height = h + 'px';
        body.style.opacity = '1';
        body.style.paddingBottom = pad;

        body.offsetHeight;                   /* ← FORÇA O REFLOW. É isto que faz
                                                 a transição existir. */

        body.style.transition =
          'height ' + DUR + 'ms ' + EASE +
          ', padding-bottom ' + DUR + 'ms ' + EASE +
          ', opacity 200ms ' + EASE;
        body.style.height = '0px';
        body.style.paddingBottom = '0px';
        body.style.opacity = '0';

        window.setTimeout(function () {
          d.open = false;
          d.classList.remove('is-closing');
          clear();
          busy = false;
        }, DUR + 20);

      } else {
        /* ---- ABRIR ---- */
        d.open = true;
        var target = body.scrollHeight;

        body.style.transition = 'none';
        body.style.overflow = 'hidden';
        body.style.height = '0px';
        body.style.paddingBottom = '0px';
        body.style.opacity = '0';

        body.offsetHeight;                   /* ← FORÇA O REFLOW */

        body.style.transition =
          'height ' + DUR + 'ms ' + EASE +
          ', padding-bottom ' + DUR + 'ms ' + EASE +
          ', opacity 260ms 60ms ' + EASE;
        body.style.height = target + 'px';
        body.style.paddingBottom = pad;
        body.style.opacity = '1';

        window.setTimeout(function () {
          clear();                            /* devolve altura auto: o conteúdo
                                                 pode refluir depois */
          busy = false;
        }, DUR + 40);
      }
    });
  }

  /* ----------------------------------------------------------------- reveal
     Cascade: os filhos [data-cascade] entram escalonados. */
  function initReveal() {
    /* ⚠️ [data-cascade] TAMBÉM precisa entrar aqui. O CSS zera a opacidade dos
       filhos e só a devolve com .is-in — sem observar, eles somem para sempre. */
    var els = [].slice.call(document.querySelectorAll('.vx [data-reveal], .vx [data-cascade]'))
      .filter(function (el) { return claim(el, 'vxRev'); });
    if (!els.length) return;

    if (REDUCED || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------- carrossel */
  function initCarousel(root) {
    if (!claim(root, 'vxCar')) return;
    var track = root.querySelector('[data-car-track]');
    var dots = root.querySelectorAll('[data-car-dot]');
    if (!track || track.children.length < 2) return;
    var n = track.children.length;

    function sync() {
      var i = Math.round(track.scrollLeft / (track.scrollWidth / n));
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    track.addEventListener('scroll', function () {
      window.clearTimeout(track._t);
      track._t = window.setTimeout(sync, 90);
    }, { passive: true });

    function go(k) {
      track.scrollTo({ left: (track.scrollWidth / n) * (((k % n) + n) % n), behavior: REDUCED ? 'auto' : 'smooth' });
    }

    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { go(k); pause(); });
    });

    /* autoplay. No desktop o track vira grade e deixa de rolar, então o
       avanço não faz nada e é inofensivo. */
    var delay = parseInt(root.getAttribute('data-autoplay') || '0', 10);
    var timer = null;
    function play() {
      if (!delay || REDUCED) return;
      stop();
      timer = window.setInterval(function () {
        go(Math.round(track.scrollLeft / (track.scrollWidth / n)) + 1);
      }, delay);
    }
    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
    function pause() { stop(); window.setTimeout(play, delay * 2); }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    track.addEventListener('touchstart', stop, { passive: true });
    play();
  }

  /* --------------------------------------------------- contador de números */
  function initCounters() {
    var els = [].slice.call(document.querySelectorAll('.vx [data-count]'))
      .filter(function (el) { return claim(el, 'vxCnt'); });
    if (!els.length) return;

    if (REDUCED || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.textContent = el.getAttribute('data-count'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        io.unobserve(el);
        var target = parseFloat(el.getAttribute('data-count'));
        var suffix = el.getAttribute('data-suffix') || '';
        if (isNaN(target)) { el.textContent = el.getAttribute('data-count'); return; }
        var t0 = null, dur = 1200;
        function step(ts) {
          if (!t0) t0 = ts;
          var k = Math.min((ts - t0) / dur, 1);
          var eased = 1 - Math.pow(1 - k, 3);
          el.textContent = Math.round(target * eased).toLocaleString('en-US') + suffix;
          if (k < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* -------------------------------------------- parallax leve na mídia solta
     Só desktop, só quando a seção está no viewport. Barato: usa rAF + IO. */
  function initParallax() {
    if (REDUCED || window.innerWidth < 900) return;
    var els = [].slice.call(document.querySelectorAll('.vx [data-parallax]'))
      .filter(function (el) { return claim(el, 'vxPar'); });
    if (!els.length || !('IntersectionObserver' in window)) return;

    var live = [];
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var i = live.indexOf(en.target);
        if (en.isIntersecting && i < 0) live.push(en.target);
        if (!en.isIntersecting && i >= 0) live.splice(i, 1);
      });
      if (live.length) tick();
    }, { rootMargin: '20% 0px' });
    els.forEach(function (el) { io.observe(el); });

    var raf = 0;
    function tick() {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var vh = window.innerHeight;
        live.forEach(function (el) {
          var r = el.getBoundingClientRect();
          var p = (r.top + r.height / 2 - vh / 2) / vh;          // -1 .. 1
          var amt = parseFloat(el.getAttribute('data-parallax')) || 14;
          el.style.setProperty('--vx-par', (p * amt * -1).toFixed(2) + 'px');
        });
        if (live.length) tick();
      });
    }
    window.addEventListener('scroll', tick, { passive: true });
    tick();
  }

  /* --------------------------------------------------------------- sticky ATC
     Mostra a barra quando a CTA da buybox já rolou para cima da tela. */
  function initSticky() {
    var bar = document.querySelector('[data-stick]');
    var sentinel = document.querySelector('[data-stick-sentinel]');
    if (!bar || !sentinel || !('IntersectionObserver' in window)) return;
    if (!claim(bar, 'vxStick')) return;

    /* o sentinela fica no FIM da buybox. Enquanto ele estiver visível ou abaixo,
       esconde a barra; quando rola para cima dele, mostra. rootMargin negativo
       no topo evita que a barra pisque na dobra. */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var past = en.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', past && !en.isIntersecting);
      });
    }, { threshold: 0, rootMargin: '0px 0px 0px 0px' });
    io.observe(sentinel);

    /* A barra sticky reaproveita a form principal (#vx-atc), que está
       envolvida no product-form-component do Horizon: requestSubmit() dispara
       o handleSubmit → add via AJAX + abre o cart drawer. Sem redirect. */
    var addBtn = bar.querySelector('[data-stick-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var form = document.getElementById('vx-atc');
        addBtn.classList.add('is-loading');
        var done = function () { setTimeout(function () { addBtn.classList.remove('is-loading'); }, 1400); };

        if (form && form.requestSubmit) {
          form.requestSubmit();
          done();
          return;
        }

        /* Fallback: sem a form hidratada, adiciona via AJAX e abre o drawer
           clicando no gatilho do header (sem redirecionar para /cart). */
        var id = addBtn.getAttribute('data-variant');
        if (!id) { done(); return; }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: 'cart-drawer-section' })
        }).then(function (r) { return r.json(); })
          .then(function () {
            var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
            if (trigger) trigger.click();
            done();
          })
          .catch(function () { done(); });
      });
    }
  }

  /* -------------------------------------------------------------------- boot */
  function boot() {
    document.querySelectorAll('[data-gal]').forEach(initGallery);
    document.querySelectorAll('[data-car]').forEach(initCarousel);
    document.querySelectorAll('.vx details').forEach(initDetails);
    initReveal();
    initCounters();
    initParallax();
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
